import React, {Component} from 'react';

export default class ToggleButton extends Component{
    render(){
        return(
            <div className="parameter-btn">
                <span>{this.props.text}</span>
                <div className="buttons">
                    <button type="button" 
                        className={'btn customer-style start '+(this.props.value?'selected':'')} 
                        onClick={() => {if (!this.props.value) this.props.onClick()}}
                        title="Aktivierung erzwingen"
                    >On</button>
                    <button type="button" 
                        className={'btn customer-style end '+(!this.props.value?'selected':'')} 
                        onClick={() => {if (this.props.value) this.props.onClick()}}
                        title="Deaktivierung erzwingen"
                    >Off</button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/overview/components/toggle-button.component.js